import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx/lite";
import extractIdFromGid from "helpers/extract-gid";
import useCartQuantityActions from "hooks/useCartQuantityActions";

const CartItemControls = ({ product, onRemoved }) => {
	const { updating, checkoutUrl } = useSelector((state) => state.cart);
	const { isFreeGift, updateQuantity } = useCartQuantityActions({ product, onRemoved });
	const { variant, disableInputs } = product || {};
	if (!variant) return null;

	const buttonClass = "plus-minus-button !size-5 !rounded-[37px]";

	const gid = extractIdFromGid(variant?.id);

	if (!checkoutUrl) return <div className="h-[173px]" />;

	return (
		<div className="flex md:m-auto md:justify-center items-center">
			<div className={clsx("flex gap-4 items-center", variant.weight <= 1 && "justify-start")}>
				<button
					id={`minus-action-${gid}`}
					aria-label="Minus"
					disabled={updating || disableInputs}
					className={clsx(buttonClass, "bg-minus-grey", disableInputs && "opacity-20 pointer-events-none")}
					onClick={() => updateQuantity(-1)} />
				<p className={clsx("text-base", "text-secondary")}>
					{product?.quantity}
				</p>
				<button
					id={`plus-action-${gid}`}
					aria-label="Plus"
					disabled={updating || disableInputs}
					className={clsx(buttonClass, "bg-plus-grey", (isFreeGift || disableInputs) && "opacity-20 pointer-events-none")}
					onClick={() => updateQuantity(1)} />
			</div>
		</div>
	);
};

export default CartItemControls;
